import get from 'lodash/get';

const SET_ENTERPRISE_LIST = 'ENTERPRISE.SET_ENTERPRISE_LIST';
const SET_ENTERPRISE_USERS = 'ENTERPRISE.SET_ENTERPRISE_USERS';
const SET_ENTERPRISE_SETTING = 'ENTERPRISE_SETTING.SET_ENTERPRISE_SETTING';
const SET_REPORT_TYPE_LIST = 'ENTERPRISE.SET_REPORT_TYPE_LIST';
const SET_COUNTRY_LIST = 'ENTERPRISE.SET_COUNTRY_LIST';
const SET_EMAIL_TEMPLATE_LIST = 'ENTERPRISE.SET_EMAIL_TEMPLATE_LIST';
const SET_CTMS_REFRESH_DATE = 'ENTERPRISE.SET_CTMS_REFRESH_DATE';
const SET_VERSION = 'ENTERPRISE.SET_VERSION';
const SET_WEB_ACCESS_TOKEN = 'ENTERPRISE.SET_WEB_ACCESS_TOKEN';

const SET_AUDIT_REPORT_TYPE_LIST = 'ENTERPRISE.SET_AUDIT_REPORT_TYPE_LIST';

const responseAction = actionName => response => ({
    type: actionName,
    response
});

export const setEnterpriseList = responseAction(SET_ENTERPRISE_LIST);
export const setEnterpriseUsers = responseAction(SET_ENTERPRISE_USERS);
export const setCountryList = responseAction(SET_COUNTRY_LIST);
export const setReportTypeList = responseAction(SET_REPORT_TYPE_LIST);
export const setEmailTemplateList = responseAction(SET_EMAIL_TEMPLATE_LIST);
export const setCtmsRefreshDate = responseAction(SET_CTMS_REFRESH_DATE);
export const setVersionNumber = responseAction(SET_VERSION);
//Audit Reports
export const setAuditReportTypeList = responseAction(SET_AUDIT_REPORT_TYPE_LIST);
export const setWebAccessToken = responseAction(SET_WEB_ACCESS_TOKEN);


const setEnterpriseSetting = setting => value => ({
    type: SET_ENTERPRISE_SETTING,
    setting,
    value
});

export const setDataSources = setEnterpriseSetting('dataSources');
export const setUserRoles = setEnterpriseSetting('userRoles');

export const getEnterpriseById = (state, id) => getAvailableEnterprises(state)[id];
export const getUserById = (state, id) => getEnterpriseUsers(state)[id];
export const getAvailableEnterprises = state => state.enterprise.availableEnterprises.enterprises;
export const getEnterpriseUsers = state => state.enterprise.enterpriseUsers.users;
export const getEnterpriseSetting = (state, setting) => state.enterprise.settings[setting];
export const getCountryList = state => state.enterprise.countries;
export const getReportTypeList = state => state.enterprise.reports;
export const getEmailTemplateList = state => state.enterprise.emailTemplates;
export const getLastCtmsRefreshDate = state => state.enterprise.lastCtmsRefresh;
export const getVersionNumber = state => state.enterprise.version;
export const getWebAccessTokenFromState = state => state.enterprise.webAccessToken;

export const getAuditReportTypeList = state => state.enterprise.auditReports;
/**
 * Initialize Enterprise state object.
 */
const initialState = {
    enterpriseUsers: {
        users: {}
    },
    availableEnterprises: {
        enterprises: {}
    },
    settings: {
        dataSources: [],
        userRoles: []
    },
    countries: [],
    reports: [],
    auditReports: [],
    emailTemplates: [],
    lastCtmsRefresh: null,
    webAccessToken: null,
};

const updateStoreFromResponse = (storeKey, state, action) => ({
    ...state,
    [storeKey]: get(action, 'response.data.content')
});

const updateStoreFromResponseReportType = (storeKey, state, action) => ({
    ...state,
    [storeKey]: get(action, 'response.data')
});

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_ENTERPRISE_LIST: {
            const { response } = action;

            return Object.assign({}, state, {
                availableEnterprises: {
                    enterprises: arrayToObject('entId', response.data.content),
                    total: response.data.totalElements
                }
            });
        }
        case SET_ENTERPRISE_USERS: {
            const { response } = action;

            return Object.assign({}, state, {
                enterpriseUsers: {
                    users: arrayToObject('enterpriseUserId', response.data.content),
                    total: response.data.totalElements
                }
            });
        }
        case SET_ENTERPRISE_SETTING: {
            return Object.assign({}, state, {
                settings: {
                    ...state.settings,
                    [action.setting]: action.value.data
                }
            });
        }
        case SET_COUNTRY_LIST: {
            return updateStoreFromResponse('countries', state, action);
        }
        case SET_REPORT_TYPE_LIST: {
            return updateStoreFromResponseReportType('reports', state, action);
        }
        case SET_AUDIT_REPORT_TYPE_LIST: {
            return updateStoreFromResponseReportType('auditReports', state, action);
        }
        case SET_EMAIL_TEMPLATE_LIST: {
            return updateStoreFromResponse('emailTemplates', state, action);
        }
        case SET_CTMS_REFRESH_DATE: {
            return {
                ...state,
                lastCtmsRefresh:
                    action && action.response.data && get(action, 'response.data.completedDate')
            };
        }
        case SET_VERSION: {
            const d = get(action, 'response.data', '');
            return {
                ...state,
                version: typeof d === 'string' ? d.trim() : ''
            };
        }
        case SET_WEB_ACCESS_TOKEN: {
            return {
                ...state,
               // webAccessToken: action.response.data ? action.response.data : action.response,
                webAccessToken: get(action, 'response.data', null)   
            };
        }
        default:
            return state;
    }
};

const arrayToObject = (key, array) => {
    return array.reduce((acc, obj) => Object.assign(acc, { [obj[key]]: obj }), {});
};
